import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { register, unregister } from './registerServiceWorker';
global.Intl = require('intl');
ReactDOM.render(<App/>, document.getElementById('root'));

unregister()
